import type { Review } from '../types/shop';

export const featuredReview: Review = {
  quote:
    'Somebody backed into my Outback in a parking lot and I was dreading the insurance process. They handled everything with State Farm, texted me photos during the repair, and had it back two days early. You honestly cannot tell where the damage was.',
  name: 'Karen M.',
  vehicle: '2019 Subaru Outback',
};

export const reviews: Review[] = [
  {
    quote:
      'Hail wrecked the hood and roof of my truck last July. They got me in within a week and did it all paintless. Fair price, great people.',
    name: 'Dustin R.',
    vehicle: '2021 Ford F-150',
  },
  {
    quote:
      "Matched the pearl white on my Lexus perfectly. I've tried three shops in Helena over the years and this is the only one I'll go back to.",
    name: 'Elena P.',
    vehicle: '2018 Lexus RX',
  },
];
